import { createStyles, makeStyles } from '@mui/styles';
import { STYLE } from '../../../../constants';

export const useStyles = makeStyles(theme =>
  createStyles({
    countryFlagDropdown: {
      opacity: '1 !important',
      '&.MuiOutlinedInput-root': {
        height: '48px !important',
        paddingLeft: '0px !important',
        paddingRight: '0px !important',
        marginLeft: '-20px',
        width: 64,
        '& .MuiSelect-select': {
          paddingLeft: '20px !important',
          height: '48px !important',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-start',
        },
        '& svg': {
          right: '0',
          borderRight: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
        },
        '& .MuiSelect-iconOpen': {
          borderLeft: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
          borderRight: 'none !important',
        },
        '& .MuiSelect-icon': {
          right: '0px !important',
          top: 'inherit !important',
        },
      },
      '& fieldset': {
        display: 'none !important',
      },
    },
    menu: {
      height: '300px',
      width: '400px',
      top: '10px !important',
      left: '-34px !important',
      borderWidth: '0px !important',
    },
    menuItem: {
      height: '40px',
      paddingLeft: '16px',
      paddingRight: '16px',
      '&.Mui-selected': {
        backgroundColor: `${STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3} !important`,
      },
    },
    countryFlag: {
      height: '24px',
      width: '24px',
      borderRadius: 8,
      marginRight: '12px',
    },
    countryFlagSelected: {
      height: '24px',
      width: '24px',
      borderRadius: 8,
      paddingLeft:'0 !important',
      paddingRight:'0 !important',
      borderWidth: 0,
    },
    countryName: {
      fontWeight: '400 !important',
      fontSize: `14px !important`,
      lineHeight: '20px !important',
      color: `${STYLE.COLOR.TEXT1} !important`,
      marginRight: '8px !important',
    },
    countryCode: {
      fontWeight: '400 !important',
      fontSize: `14px !important`,
      lineHeight: '20px !important',
      color: `${STYLE.COLOR.TEXT2} !important`,
    },
  }),
);
